module.exports = __webpack_public_path__ + "static/media/payment.59ff02b3.svg";